//Custom Imports
import { contestType } from "@reducers/actionTypes";
import { asyncActionCreator, actionCreator } from "./redux.action";

const getLiveUpcomingContest = asyncActionCreator(
  contestType.GET_LIVE_UPCOMING,
  contestType.GET_LIVE_UPCOMING_SUCCESS,
  contestType.GET_LIVE_UPCOMING_ERROR,
  contestType.GET_LIVE_UPCOMING_FETCHED,
);

const getPastContest = asyncActionCreator(
  contestType.GET_PAST_CONTEST,
  contestType.GET_PAST_CONTEST_SUCCESS,
  contestType.GET_PAST_CONTEST_ERROR,
  contestType.GET_PAST_CONTEST_FETCHED,
);

const getContestDetailsContest = asyncActionCreator(
  contestType.GET_CONTEST_DETAILS,
  contestType.GET_CONTEST_DETAILS_SUCCESS,
  contestType.GET_CONTEST_DETAILS_ERROR,
  contestType.GET_CONTEST_DETAILS_FETCHED,
);

const getMyCustomersContest = asyncActionCreator(
  contestType.GET_MY_CUSTOMERS,
  contestType.GET_MY_CUSTOMERS_SUCCESS,
  contestType.GET_MY_CUSTOMERS_ERROR,
  contestType.GET_MY_CUSTOMERS_FETCHED,
);

const getContestCxOrderedContest = asyncActionCreator(
  contestType.GET_CONTEST_CX_ORDERED,
  contestType.GET_CONTEST_CX_ORDERED_SUCCESS,
  contestType.GET_CONTEST_CX_ORDERED_ERROR,
  contestType.GET_CONTEST_CX_ORDERED_FETCHED,
);

const updateMoreCustomerLoading = actionCreator(
  contestType.MORE_CUSTOMERS_LOADING,
);
const updateMoreOrderedCustLoading = actionCreator(
  contestType.MORE_ORDERED_CUSTOMERS_LOADING,
);

export default {
  getPastContest,
  getMyCustomersContest,
  getLiveUpcomingContest,
  getContestDetailsContest,
  updateMoreCustomerLoading,
  getContestCxOrderedContest,
  updateMoreOrderedCustLoading,
};
